// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonAppHelp_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18 0H0V24H12.7084C11.9353 23.3177 11.2951 22.4883 10.8316 21.5556C10.6522 21.8236 10.3467 22 10 22H8C7.44772 22 7 21.5523 7 21C7 20.4477 7.44772 20 8 20H10C10.0903 20 10.1778 20.012 10.261 20.0344C10.0907 19.3848 10 18.703 10 18H2V2H16V10.252C16.6392 10.0875 17.3094 10 18 10V0ZM24 18C24 21.3137 21.3137 24 18 24C14.6863 24 12 21.3137 12 18C12 14.6863 14.6863 12 18 12C21.3137 12 24 14.6863 24 18ZM17.9686 13.5C19.6426 13.5 21 14.6841 21 16.1449C21 17.1171 20.3989 17.9662 19.5028 18.4254H19.5046C19.2344 18.5564 19.0263 18.7722 18.9278 19.0316H18.9311V19.5H17.0993V19.0316H17.0977C17.1287 18.8207 17.1879 18.618 17.272 18.4254C17.5211 17.8602 17.9849 17.387 18.5779 17.0853C18.9531 16.8995 19.2073 16.5475 19.2073 16.1449C19.2073 15.5488 18.6516 15.064 17.9684 15.064C17.2858 15.064 16.7296 15.5488 16.7296 16.1449L15 15.6062C15.2853 14.4037 16.5065 13.5 17.9686 13.5ZM17 22.5V20.5H19V22.5H17Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonAppHelp is a generated icon component.
 */
let IconCommonAppHelp = IconCommonAppHelp_1 = class IconCommonAppHelp extends IconBaseElement {
    render() {
        return html `${IconCommonAppHelp_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonAppHelp.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonAppHelp = IconCommonAppHelp_1 = __decorate([
    customElement('zui-icon-common-app-help')
], IconCommonAppHelp);
export { IconCommonAppHelp };
